import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  getCurrentAccountUid,
  selectAccountAgreementHtml,
} from '../../store/selectors/accountSelectors';
import { fetchAccountAgreementHtml } from '../../store/actions/account/accountActions';
import { selectIsLoadingByActionType } from '../../store/selectors/loadingSelectors';
import { FETCH_ACCOUNT_AGREEMENT_HTML_LOADING } from '../../store/actions/account/accountActionConstants';
import SectionLoader from '../Loader/SectionLoader';
import themeColors from '../../assets/styles/themeColors';

const AgreementWrap = styled.div`
  min-height: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 24px;

  .ps-contract {
    display: flex !important;
    flex-direction: column !important;

    div,
    p {
      font-size: 16px !important;
    }
  }

  .ps-contract-scroll {
    max-height: 100% !important;
    overflow: none !important;
  }

  .ps-contract-body,
  .ps-contract {
    padding: 0 !important;
    border-width: 0 !important;

    > div {
      > span {
        margin-bottom: calc(1.5rem * var(--legacy-scale, 1)) !important;
        display: inline-block !important;
        font-size: 14px !important;
      }
    }
  }

  .ps-contract-title,
  .ps-contract-options,
  .ps-checkbox-container {
    display: none !important;
  }

  h2 {
    text-align: center !important;
  }

  h2,
  h3 {
    font-weight: 600 !important;
    margin-bottom: calc(1.5rem * var(--legacy-scale, 1)) !important;
    margin-top: 0 !important;
  }

  h3 {
    margin-top: calc(0.5rem * var(--legacy-scale, 1)) !important;
    margin-bottom: calc(1rem * var(--legacy-scale, 1)) !important;
  }

  p {
    margin-bottom: calc(1.5rem * var(--legacy-scale, 1)) !important;
    margin-top: 0 !important;
  }

  a {
    color: ${themeColors.colorTextSecondary};
    text-decoration: underline !important;
    font-weight: 600;
    font-size: inherit;
  }

  ul,
  ol {
    margin-bottom: calc(1.5rem * var(--legacy-scale, 1)) !important;
  }

  table {
    td,
    th {
      border: 1px solid #dee2e6 !important;
      padding: 2px !important;
      vertical-align: bottom !important;
    }

    th {
      font-weight: 600 !important;
      text-align: center !important;
    }

    thead {
      background-color: #d9d9d9 !important;
    }

    tbody {
      tr {
        > :first-child {
          font-weight: 600 !important;
          background-color: #d9d9d9 !important;
        }

        > :not(:first-child) {
          text-align: center !important;
        }
      }
    }
  }
`;

const AgreementDisplay = ({ type, hideLoader, signTheDoc }) => {
  const accountUid = useSelector(getCurrentAccountUid);
  const agreement = useSelector(selectAccountAgreementHtml);
  const dispatch = useDispatch();

  const isLoading = useSelector(
    selectIsLoadingByActionType(FETCH_ACCOUNT_AGREEMENT_HTML_LOADING),
  );

  useEffect(() => {
    dispatch(
      fetchAccountAgreementHtml({
        agreementType: type,
        accountUid,
        signTheDoc,
      }),
    );
  }, [accountUid, dispatch, type, signTheDoc]);

  return (
    <AgreementWrap id="divToDownload">
      <SectionLoader isLoading={!hideLoader && isLoading}>
        {ReactHtmlParser(agreement)}
      </SectionLoader>
    </AgreementWrap>
  );
};

AgreementDisplay.propTypes = {
  type: PropTypes.string,
  // Suppress this component's own SectionLoader when a parent (e.g. PrintModal)
  // already shows a loading overlay, to avoid a double spinner.
  hideLoader: PropTypes.bool,
  // Optional GET html flag (Price Alerts passes false); omitted otherwise.
  signTheDoc: PropTypes.bool,
};

export default AgreementDisplay;
